// EVE-Modus-Labels für die Wissens-Zuweisung (Admin „Wissen"-Tab).
// Muss zu EVE_AGENT_KEYS im Backend (api/src/lib/knowledge/agent-keys.ts) passen.
export const EVE_MODE_OPTIONS: ReadonlyArray<{ key: string; label: string }> = [
  { key: 'direct', label: 'Chat' },
  { key: 'lagebild', label: 'Lagebild' },
  { key: 'morgenbriefing', label: 'Morgenbriefing' },
  { key: 'marktupdate', label: 'Marktupdate' },
  { key: 'moneyflow', label: 'Money-Flow' },
  { key: 'breaking', label: 'Breaking' },
  { key: 'wochenendrueckblick', label: 'Wochenrückblick' },
  { key: 'chartanalyse', label: 'Chart-Analyse' },
  { key: 'academy', label: 'Academy' },
];
